import { CALL_API } from 'middleware/api';
import { getMyLimitsApiActions } from 'features/settings/plan-overview/reducers/myLimits';
import { DELETE_BENEFICIARY_FAILURE, DELETE_BENEFICIARY_REQUEST, DELETE_BENEFICIARY_SUCCESS, } from 'actions/types';
import { apiEvents } from '../constants';
export function createPayee({ name, reference, accountNumber, sortCode, }) {
    return {
        [CALL_API]: {
            endpoint: `/beneficiaries`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name,
                reference,
                accountNumber,
                sortCode: sortCode.replace(/[\D]/g, ''),
            }),
            types: apiEvents.createPayee,
        },
    };
}
export function updatePayee(id, { name, reference, accountNumber, sortCode }) {
    return {
        [CALL_API]: {
            endpoint: `/beneficiaries/${id}`,
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name,
                reference,
                accountNumber,
                sortCode: sortCode.replace(/[\D]/g, ''),
            }),
            types: apiEvents.updatePayee,
        },
    };
}
export function getPayees() {
    return {
        [CALL_API]: {
            endpoint: `/beneficiaries`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: apiEvents.getPayees,
        },
    };
}
export function removePayee(id) {
    return {
        [CALL_API]: {
            endpoint: `/beneficiaries/${id}`,
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: [
                DELETE_BENEFICIARY_REQUEST,
                DELETE_BENEFICIARY_SUCCESS,
                DELETE_BENEFICIARY_FAILURE,
            ],
            extra: { id },
        },
    };
}
export function getMyLimits() {
    return {
        [CALL_API]: {
            endpoint: `/payments/my-limits`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: getMyLimitsApiActions,
        },
    };
}
export default {
    createPayee,
    updatePayee,
    getPayees,
    removePayee,
    getMyLimits,
};
